export var SharingCapability;
/**
 * Specifies if given social sharing service supports specific sharing features,
 * like sharing text w/o specifying URL etc.
 */

(function (SharingCapability) {
  SharingCapability["ShareText"] = "text";
  SharingCapability["ShareUrl"] = "URL";
  SharingCapability["ShareUrlAndText"] = "URL and text";
})(SharingCapability || (SharingCapability = {}));